<template>
  <div>
    <modal-form v-model="show" :submit="submit">
      <template v-slot:title> {{ ID ? "Editar" : "Novo" }} SMTP </template>
      <template v-slot:body>
        <v-row>
          <v-col cols="12">
            <input-text
              label="ID"
              v-model="model.id"
              :disabled="true"
              v-if="model.id"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <input-text
              label="Host"
              v-model="model.host"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <input-text
              label="Port"
              v-model="model.port"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <input-text
              label="Account (User)"
              v-model="model.account"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <input-text
              type="password"
              label="Password"
              v-model="model.password"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-switch label="Use SSL" v-model="model.useSSL" required>
            </v-switch>
          </v-col>
        </v-row>
      </template>
    </modal-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      model: {},
      ID: '',
      items: []
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      th.model = {}
      if (sender) {
        th.model = sender
        th.ID = th.model.id
      } else th.ID = ''
    },
    submit () {
      const th = this
      th.$api.EmailSMTP.Persist(th.model, th.model.id ? 'id' : '').then(
        function (response) {
          if (th.$api.UI.PostAction(response)) {
            th.show = false
            th.$emit('close', !response.error)
          }
        }
      )
    }
  }
}
</script>
